import React from 'react'
import styled from '@emotion/styled'
import { Box } from '@mui/material'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'

const StyledColorBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: circlesOrbitColorPalette.neutrals.background,
  padding: '1vh',
  borderRadius: '8px',
  marginTop: '1vh'
})

interface ColorBoxProps {
  children: React.ReactNode
}

const ColorBoxInfo = (props: ColorBoxProps) => {
  const { children } = props
  return <StyledColorBox>{children}</StyledColorBox>
}

export default ColorBoxInfo
